import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: '1rem',
    [theme.breakpoints.up('md')]: {
      padding: '2rem 2.125rem'
    }
  },
  profileHead: {
    marginBottom: '1.625rem'
  },
  amendment: {
    padding: '2rem',
    marginBottom: '2rem'
  },
  mobileOnly: {
    minWidth: '4rem',
    width: '4rem',
    marginRight: '1.5rem'
  },
  desktopOnly: {
    height: '5rem'
  },
  amendmentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
      width: 'auto',
      marginLeft: '2rem'
    }
  },

  amendmentDescription: {
    marginTop: '1.25rem',
    color: theme.palette.focus50.main,
    '& span': {
      color: theme.palette.peace40.main,
      marginLeft: '4px',
      fontWeight: 'bold'
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '0px',
      textAlign: 'left'
    }
  },

  amendmentButton: {
    ...theme.typography.body_extraLargeBold,
    margin: '1.5625rem auto auto',
    [theme.breakpoints.up('md')]: {
      margin: '0 auto auto'
    },
    [theme.breakpoints.up('lg')]: {
      margin: '0 0 0 auto'
    }
  }
}));

export default useStyles;
